// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__k0ZJ2","card":"Error_card__3bKMk","row":"Error_row__1_ZD2"};